// import Raven from 'raven-js'
// window.Sentry = Sentry

import 'raven-init'
